import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-service-unique-id',
  templateUrl: './service-unique-id.component.html',
  styleUrls: ['./service-unique-id.component.scss']
})
export class ServiceUniqueIdComponent implements OnInit {
  AccountForm!: FormGroup;
  isDomainAvailable: boolean | null = null;
  domainCheckInProgress: boolean = false;
  subscription = new Subscription;
  adminDetails: any = {};
  refreshData: boolean = false;
  sellerDetails: any = {};
  OnBoardingConfiguration: any = {};
  isEdit: boolean = false;
  isSubDomainAdded: boolean = false;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;
  branchInfo: any;

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public configService: ConfigService,
  ) { }

  ngOnInit(): void {
    this.setAllForms();
    this.adminDetails = this.configService.getLoginDetails();
    this.getSellerConfiguration();
    // this.AccountForm.get('uniqueID')?.setValue(
    //   this.adminDetails?.SellerName.replace(/\s+/g, ''),
    //   { emitEvent: true }
    // );

  }

  private setAllForms() {
    this.AccountForm = this.fb.group({
      uniqueID: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]+$/)]],
    });

    this.AccountForm.get('uniqueID')?.valueChanges.subscribe(value => {
      if (!value || this.AccountForm.invalid) {
        this.isDomainAvailable = null;
        return;
      }
      this.checkDomainExist(value);
    });
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 3000);
  }

  private checkDomainExist(subdomain: string) {
    let domain = subdomain;
    this.isDomainAvailable = null;
    this.domainCheckInProgress = true;
    if (domain) {
      this.adminService.checkSubdomainExist(domain).subscribe((res: any) => {

        if (res.Result === 'Success' && res.ResponseData === 'Not Exist') {
          this.isDomainAvailable = true;

        } else {
          this.isDomainAvailable = false;
        }
        this.domainCheckInProgress = false;
      },
        (err: HttpErrorResponse) => {
          this.isDomainAvailable = false;
          this.domainCheckInProgress = false;
        });
    } else {
      this.isDomainAvailable = false;
      this.domainCheckInProgress = false;
    }
  }

  private getSellerConfiguration() {
    this.configService.getSellerSettingsBySellerId({ filters: "WebsiteTheme"}).subscribe((res: any) => {
      if (res?.Result == "Success" && res?.ResponseData) {
        const SellerSettingsData = JSON.parse(res?.ResponseData.WebsiteTheme);
        const SellerSocialMedia = JSON.parse(res?.ResponseData.SocialMediaLinks);
        SellerSettingsData.SocialMediaLinks = SellerSocialMedia;
        this.OnBoardingConfiguration = SellerSettingsData;

        const uniqueServiceID = this.OnBoardingConfiguration?.SubDomainPath;

        if(uniqueServiceID){
          this.AccountForm.get('uniqueID')?.setValue(
            uniqueServiceID,
            { emitEvent: false }
          );
          this.isEdit = true;
          this.isSubDomainAdded = true;
        }
        
      }
    }, (err: HttpErrorResponse) => {

    })
  }

  public saveUniqueID() {
    let params = {
      shopName: this.adminDetails?.SellerName,
      subDomain: this.AccountForm.get('uniqueID')?.value,
      uniqueIdentifier: this.AccountForm.get('uniqueID')?.value,
    };

    this.subscription.add(this.adminService.SaveSellerSubdominAndDetails(params).subscribe((res: any) => {
      if (res.Result == "Success" && res.ResponseData) {
        this.notify(true, 'Unique ID saved successfully.');
        this.getSellerConfiguration();
        this.closeEditMode();
        this.isDomainAvailable = null;
      } else {
        this.notify(false, 'Failed to save. Please try again.');
      }
    },
      (error: HttpErrorResponse) => {
        this.notify(false, 'Failed to save. Please try again.');
      }
    ));
  }

  public openEditMode(){
    this.isEdit = false;
  }

  public closeEditMode(){
    this.isDomainAvailable = null;
    this.getSellerConfiguration();
    this.isEdit = true;
  }

  public clearUniqueID(){
    this.AccountForm.get('uniqueID')?.setValue('');
  }

}
